import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import TeacherModuleChrome from "../teacher/module/TeacherModuleChrome";

/**
 * Shared chrome for teachers: gradient page + "Hello {name}" + Menu (no sidebar / no grade header).
 * Use {@link TeacherShellFrame} when you need to wrap a page directly (e.g. dashboard).
 * Use {@link TeacherShellLayout} for nested routes (Outlet).
 */
export function TeacherShellFrame({ children }) {
	const { loading } = useAuth();

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100vh"
				sx={{ backgroundColor: "#e8f4fc" }}>
				<CircularProgress size={28} sx={{ color: "#16a34a" }} />
			</Box>
		);
	}

	return (
		<Box sx={{ minHeight: "100vh", backgroundColor: "#f3f4f6" }}>
			<TeacherModuleChrome>{children}</TeacherModuleChrome>
		</Box>
	);
}

const TeacherShellLayout = () => {
	return (
		<TeacherShellFrame>
			<Outlet />
		</TeacherShellFrame>
	);
};

export default TeacherShellLayout;
